import type { Issue } from "../types";

const DETAIL_KEYS = new Set([
  "diag.combined-battery-discharge.detail_message",
  "diag.combined-battery-discharge.detail_fix",
  "diag.ac-onto-dc-rail.detail_fix",
  "diag.ac-onto-dc-rail.detail_message",
  "diag.battery-missing-terminal-fuse.detail_fix",
  "diag.battery-missing-terminal-fuse.detail_message",
  "diag.bms-control-unverified.detail_fix",
  "diag.bms-control-unverified.detail_message",
  "diag.charge-exceeds-acceptance.detail_fix_lead",
  "diag.charge-exceeds-acceptance.detail_fix_lfp",
  "diag.charge-exceeds-acceptance.detail_fix_specified",
  "diag.charge-exceeds-acceptance.detail_fix_recommended",
  "diag.charge-exceeds-acceptance.detail_fix_planning",
  "diag.charge-exceeds-acceptance.detail_message",
  "diag.charge-exceeds-acceptance.detail_message_specified",
  "diag.charge-exceeds-acceptance.detail_message_recommended",
  "diag.charge-exceeds-acceptance.detail_message_planning",
  "diag.charger-cumulative-vdrop.detail_fix",
  "diag.charger-cumulative-vdrop.detail_message_manufacturer",
  "diag.charger-cumulative-vdrop.detail_message_target",
  "diag.charger-cumulative-vdrop.detail_message_verify",
  "diag.charger-return-floating.detail_fix",
  "diag.charger-return-floating.detail_message",
  "diag.charger-return-floating.detail_message_dead_end",
  "diag.cranking-vdrop-unverified.detail_fix",
  "diag.cranking-vdrop-unverified.detail_message",
  "diag.fuse-identity-conflict.detail_fix",
  "diag.fuse-identity-conflict.detail_message",
  "diag.fuse-protection-unverified.detail_fix",
  "diag.fuse-protection-unverified.detail_message_declared",
  "diag.fuse-protection-unverified.detail_message_declared_placement",
  "diag.fuse-protection-unverified.detail_message_estimated",
  "diag.fuse-protection-unverified.detail_message_estimated_placement",
  "diag.fuse-protection-unverified.detail_message_series",
  "diag.fuse-protection-unverified.detail_message_series_placement",
  "diag.fuse-protection-unverified.detail_message_topology",
  "diag.fuse-protection-unverified.detail_message_topology_placement",
  "diag.fuse-protection-unverified.detail_message_unknown",
  "diag.fuse-protection-unverified.detail_message_unknown_placement",
  "diag.fuse-too-far-from-battery.detail_fix",
  "diag.fuse-too-far-from-battery.detail_message",
  "diag.inverter-dc-isolation-unverified.detail_fix",
  "diag.inverter-dc-isolation-unverified.detail_message",
  "diag.manufacturer-breaker-rating.detail_fix",
  "diag.manufacturer-breaker-rating.detail_message",
  "diag.manufacturer-breaker-unverified.detail_fix",
  "diag.manufacturer-breaker-unverified.detail_message",
  "diag.manufacturer-supplied-lead-protection.detail_fix",
  "diag.manufacturer-supplied-lead-protection.detail_message",
  "diag.missing-ground.detail_fix",
  "diag.missing-ground.detail_message",
  "diag.monitor-power-unverified.detail_fix",
  "diag.monitor-power-unverified.detail_message_missing",
  "diag.monitor-power-unverified.detail_message_protection",
  "diag.monitor-power-unverified.detail_message_voltage",
  "diag.pv-isolation-missing.detail_fix",
  "diag.pv-isolation-missing.detail_message",
  "diag.pv-isolation-unverified.detail_fix",
  "diag.pv-isolation-unverified.detail_message",
  "diag.source-current-allocation-unverified.detail_fix",
  "diag.source-current-allocation-unverified.detail_message",
  "diag.source-return-floating.detail_fix",
  "diag.source-return-floating.detail_message",
  "diag.unfused-charger-output.detail_fix",
  "diag.unfused-charger-output.detail_message"
]);

export function withIssueDetails(issue: Issue): Issue {
  const details = [...(issue.details ?? [])];
  for (const text of [issue.message, issue.fix]) {
    if (!text) continue;
    const key = text.key.replace(/\.(message|fix)/, ".detail_$1");
    if (DETAIL_KEYS.has(key)) details.push({ ...text, key });
  }
  return details.length ? { ...issue, details } : issue;
}
